import React from 'react'
import { isProd } from 'tools/env'
// Wordmarks
import LeaguesafeWordmark from 'images/icons/leaguesafe/Wordmark'
import SHGNWordmark from 'images/icons/shgn/Wordmark'
import CDMWordmark from 'images/icons/cdm/Wordmark'
import NFCWordmark from 'images/icons/nfc/Wordmark'
import NFFCWordmark from 'images/icons/nffc/Wordmark'
import NFBCWordmark from 'images/icons/nfbc/Wordmark'
import NFBKCWordmark from 'images/icons/nfbkc/Wordmark'
import FanballWordmark from 'images/icons/fanball/Wordmark'
import MFL10sWordmark from 'images/icons/mfl10s/Wordmark'
import GolfWordmark from 'images/icons/shubgolf/Wordmark'
// Shields
import LeaguesafeShield from 'images/icons/leaguesafe/Shield'
import SHGNShield from 'images/icons/shgn/Shield'
import CDMShield from 'images/icons/cdm/Shield'
import NFCShield from 'images/icons/nfc/Shield'
import NFFCShield from 'images/icons/nffc/Shield'
import NFBCShield from 'images/icons/nfbc/Shield'
import NFBKCShield from 'images/icons/nfbkc/Shield'
import FanballShield from 'images/icons/fanball/Shield'
import MFL10sShield from 'images/icons/mfl10s/Shield'
import GolfShield from 'images/icons/shubgolf/Shield'
// Mobile footer logos
import FanballMobile from 'images/icons/shgn/footerLogos/mobile/fanball.svg'
import CDMMobile from 'images/icons/shgn/footerLogos/mobile/CDM.svg'
import LeaguesafeMobile from 'images/icons/shgn/footerLogos/mobile/leaguesafe.svg'
import BB10sMobile from 'images/icons/shgn/footerLogos/mobile/BB10s.svg'
import NFBCMobile from 'images/icons/shgn/footerLogos/mobile/NFBC.svg'
import NFCMobile from 'images/icons/shgn/footerLogos/mobile/NFC.svg'
import NFFCMobile from 'images/icons/shgn/footerLogos/mobile/NFFC.svg'
import NFBKCMobile from 'images/icons/shgn/footerLogos/mobile/NFBKC.svg'
// Desktop footer logos
import FanballDesktop from 'images/icons/shgn/footerLogos/desktop/fanball.svg'
import CDMDesktop from 'images/icons/shgn/footerLogos/desktop/CDM.svg'
import LeaguesafeDesktop from 'images/icons/shgn/footerLogos/desktop/leaguesafe.svg'
import BB10sDesktop from 'images/icons/shgn/footerLogos/desktop/BB10s.svg'
import NFBCDesktop from 'images/icons/shgn/footerLogos/desktop/NFBC.svg'
import NFCDesktop from 'images/icons/shgn/footerLogos/desktop/NFC.svg'
import NFFCDesktop from 'images/icons/shgn/footerLogos/desktop/NFFC.svg'
import NFBKCDesktop from 'images/icons/shgn/footerLogos/desktop/NFBKC.svg'

const domains = {
  cdm: isProd() ? 'https://www.cdmsports.com' : 'https://cdm.shub.dog',
  nfc: isProd() ? 'https://nfc.shgn.com' : 'https://nfc.shub.dog',
  nffc: isProd() ? 'https://playnffc.shgn.com' : 'https://playnffc.shub.dog',
  nfbc: isProd() ? 'https://playnfbc.shgn.com' : 'https://playnfbc.shub.dog',
  nfbkc: isProd() ? 'https://playnfbkc.sportshubtech.com' : 'https://playnfbkc.shub.dog',
  fanball: isProd() ? 'https://www.fanball.com' : 'https://fanball-qa.shub.dog',
  mfl10s: isProd() ? 'https://mfl10s.sportshubtech.com' : 'https://mfl10s.shub.dog',
  bb10s: isProd() ? 'https://bestball10s.shgn.com' : 'https://bestball10s.shub.dog',
  leaguesafe: isProd() ? 'https://www.leaguesafe.com' : 'https://leaguesafe-qa.shub.dog',
  shubgolf: isProd() ? 'https://fantasygolfchampionships.shgn.com' : 'https://golf-qa.shub.dog',
}

// The order of the items below matters.  It is used to paint out the network nav in the correct order.
const themes = {
  fanball: {
    name: 'fanball',
    displayName: 'Fanball',
    description: 'Play Fair, Play More, Win More!',
    color: '#31ADD0',
    wordmark: <FanballWordmark theme="mainNav" />,
    wordmarkDark: <FanballWordmark theme="networkNav" />,
    wordmarkMobile: <FanballWordmark theme="light" />,
    shield: <FanballShield />,
    showInNetworkNav: true,
    siteUrl: domains.fanball,
    clientId: 'fanball-client',
    walletClientId: 'fanball',
    requiresGamblingMessage: true,
    links: [
      { text: 'What is Fanball', url: `${domains.fanball}/how-to-play`, description: 'The fairest daily fantasy games around' },
      { text: 'Check out the Lobby', url: `${domains.fanball}/lobby`, description: 'Find a contest or compete against your friends' },
    ],
    loggedInLinks: [
      { text: 'Check out the Lobby', url: `${domains.fanball}/lobby`, description: 'Find a contest or compete against your friends' },
      { text: 'My Contests', url: `${domains.fanball}/contests/upcoming`, description: 'Check out your current and previous contests' },
    ],
    footerLogoItems: {
      mobileLogo: { text: 'FanBall', image: FanballMobile, url: domains.fanball },
      desktopLogo: { text: 'Fanball', image: FanballDesktop, width: '150px', url: domains.fanball },
    },
  },
  leaguesafe: {
    name: 'leaguesafe',
    displayName: 'LeagueSafe',
    description: 'Safely Collect and Protect your League Dues',
    color: '#f5801f',
    wordmark: <LeaguesafeWordmark theme="light" />,
    wordmarkDark: <LeaguesafeWordmark />,
    shield: <LeaguesafeShield />,
    showInNetworkNav: true,
    siteUrl: domains.leaguesafe,
    clientId: 'leaguesafe',
    walletClientId: 'leaguesafe',
    requiresGamblingMessage: false,
    links: [
      { text: 'What is LeagueSafe?', url: `${domains.leaguesafe}/howitworks`, description: 'Manage your league dues and find players' },
      { text: 'Collect League Dues', url: `${domains.leaguesafe}/CreateLeague`, description: 'Simplify and secure payments for your league' },
      { text: 'League Classifieds', url: `${domains.leaguesafe}/classifieds`, description: 'Need to fill your league? Try our classifieds!' },
    ],
    loggedInLinks: [
      { text: 'My Dashboard', url: `${domains.leaguesafe}/dashboard`, description: 'Check out your current leagues and pay your league dues' },
      { text: 'Collect League Dues', url: `${domains.leaguesafe}/CreateLeague`, description: 'Simplify and secure payments for your league' },
      { text: 'Find a League', url: `${domains.leaguesafe}/classifieds`, description: 'Looking for a challenge? Find a league to join in the Classifieds.' },
    ],
    footerLogoItems: {
      mobileLogo: { text: 'Leaguesafe', image: LeaguesafeMobile, url: domains.leaguesafe },
      desktopLogo: { text: 'Leaguesafe', image: LeaguesafeDesktop, width: '169px', url: domains.leaguesafe },
    },
  },
  nffc: {
    name: 'nffc',
    displayName: 'NFFC',
    description: 'Win over $150,000 in our National Fantasy Football Championships!',
    color: '#0f98c6',
    wordmark: <NFFCWordmark theme="light" />,
    wordmarkDark: <NFFCWordmark />,
    shield: <NFFCShield />,
    showInNetworkNav: false,
    siteUrl: domains.nffc,
    clientId: 'NFFC',
    walletClientId: 'nffc',
    requiresGamblingMessage: true,
    links: [
      { text: 'High Stakes', url: `${domains.nffc}/what-is-nffc`, description: 'Learn about what makes our high stakes game popular' },
      { text: 'Tough Competition', url: `${domains.nffc}/how-to-play`, description: 'Discover how to play with top fantasy players' },
    ],
    loggedInLinks: [
      { text: 'My Teams', url: `${domains.nffc}/myTeams`, description: 'Access Your NFFC Teams' },
      { text: 'Contest Overview', url: `${domains.nffc}/overview`, description: 'Take a quick look to find the game for you' },
    ],
    footerLogoItems: {
      mobileLogo: { text: 'NFFC', image: NFFCMobile, url: domains.nffc },
      desktopLogo: { text: 'NFFC', image: NFFCDesktop, width: '111px', url: domains.nffc },
    },
  },
  nfbkc: {
    name: 'nfbkc',
    displayName: 'NFBKC',
    description: 'National Fantasy Basketball Championship. Win $10,000 and even bigger prizes',
    color: '#6c2119',
    wordmark: <NFBKCWordmark theme="light" />,
    wordmarkDark: <NFBKCWordmark />,
    shield: <NFBKCShield />,
    showInNetworkNav: false,
    siteUrl: domains.nfbkc,
    clientId: 'NFBKC',
    walletClientId: 'nfbkc',
    requiresGamblingMessage: true,
    links: [
      { text: 'High Stakes', url: `${domains.nfbkc}/what-is-nfbkc`, description: 'Learn about what makes our high stakes game popular' },
      { text: 'Tough Competition', url: `${domains.nfbkc}/how-to-play`, description: 'Discover how to play with top fantasy players' },
    ],
    loggedInLinks: [
      { text: 'My Teams', url: `${domains.nfbkc}/myTeams`, description: 'Access Your NFBKC Teams' },
      { text: 'Contest Overview', url: `${domains.nfbkc}/overview`, description: 'Take a quick look to find the game for you' },
    ],
    footerLogoItems: {
      mobileLogo: { text: 'NFBKC', image: NFBKCMobile, url: domains.nfbkc },
      desktopLogo: { text: 'NFBKC', image: NFBKCDesktop, width: '128px', url: domains.nfbkc },
    },
  },
  nfbc: {
    name: 'nfbc',
    displayName: 'NFBC',
    description: 'National Fantasy Baseball Championship. Win $150,000 and even bigger prizes!',
    color: '#00ab77',
    wordmark: <NFBCWordmark theme="light" />,
    wordmarkDark: <NFBCWordmark />,
    shield: <NFBCShield />,
    showInNetworkNav: false,
    siteUrl: domains.nfbc,
    clientId: 'NFBC',
    walletClientId: 'nfbc',
    requiresGamblingMessage: true,
    links: [
      { text: 'High Stakes', url: `${domains.nfbc}/what-is-nfbc`, description: 'Learn about what makes our high stakes game popular' },
      { text: 'Tough Competition', url: `${domains.nfbc}/how-to-play`, description: 'Discover how to play with top fantasy players' },
    ],
    loggedInLinks: [
      { text: 'My Teams', url: `${domains.nfbc}/myTeams`, description: 'Access Your NFBC Teams' },
      { text: 'Contest Overview', url: `${domains.nfbc}/overview/baseball`, description: 'Take a quick look to find the game for you' },
    ],
    footerLogoItems: {
      mobileLogo: { text: 'NFBC', image: NFBCMobile, url: domains.nfbc },
      desktopLogo: { text: 'NFBC', image: NFBCDesktop, width: '117px', url: domains.nfbc },
    },
  },
  nfc: {
    name: 'nfc',
    displayName: 'NFC',
    description: 'National Fantasy Championships. Win $200,000 and even bigger prizes!',
    color: '#22a09f',
    wordmark: <NFCWordmark theme="light" />,
    wordmarkDark: <NFCWordmark />,
    shield: <NFCShield />,
    showInNetworkNav: true,
    siteUrl: domains.nfc,
    clientId: 'NFC',
    walletClientId: 'nfc',
    requiresGamblingMessage: true,
    links: [
      { text: 'Baseball', url: `${domains.nfc}/baseball`, description: 'National Fantasy Baseball Championship. Win $150,000 and even bigger prizes!' },
      { text: 'Football', url: `${domains.nfc}/football`, description: 'National Fantasy Football Championship. Win $200,000 and even bigger prizes!' },
      { text: 'Basketball', url: `${domains.nfc}/basketball`, description: 'National Fantasy Basketball Championship. Win $10,000 and even bigger prizes!' },
    ],
    loggedInLinks: [
      { text: 'My Teams', url: `${domains.nfc}/myTeams`, description: 'Access Your NFC Teams' },
      { text: 'Contest Overview', url: `${domains.nfc}/lobby`, description: 'Take a quick look to find the game for you' },
    ],
    footerLogoItems: {
      mobileLogo: { text: 'NFC', image: NFCMobile, url: domains.nfc },
      desktopLogo: { text: 'NFC', image: NFCDesktop, width: '127px', url: domains.nfc },
    },
  },
  mfl10s: {
    name: 'mfl10s',
    displayName: 'BB10s/MFL10s',
    description: 'Premier home of Best Ball leagues',
    color: '#203b66',
    wordmark: <MFL10sWordmark theme="light" />,
    wordmarkDark: <MFL10sWordmark />,
    shield: <MFL10sShield />,
    showInNetworkNav: true,
    siteUrl: domains.bb10s,
    clientId: 'mfl10',
    walletClientId: 'mfl10',
    requiresGamblingMessage: true,
    links: [
      { text: 'BB10s Home', url: `${domains.bb10s}`, description: 'Access the BB10s Site' },
      { text: 'ADP, Rankings', url: `${domains.bb10s}/adp`, description: 'Use our draft ranking guides to help you in all your leagues' },
    ],
    loggedInLinks: [
      { text: 'My BB10s Teams', url: `${domains.bb10s}/myTeams`, description: 'Access Your BB10s Teams' },
      { text: 'Baseball ADP', url: `${domains.bb10s}/adp`, description: 'Use our draft ranking guides to help you in all your leagues' },
    ],
    footerLogoItems: {
      mobileLogo: { text: 'BB10s', image: BB10sMobile, url: domains.bb10s },
      desktopLogo: { text: 'BB10s', image: BB10sDesktop, width: '160px', url: domains.bb10s },
    },
  },
  cdm: {
    name: 'cdm',
    displayName: 'CDM Sports',
    description: 'Fantasy Games for the Passionate Sports Fan!',
    color: '#d1232a',
    wordmark: <CDMWordmark theme="light" />,
    wordmarkDark: <CDMWordmark />,
    shield: <CDMShield />,
    showInNetworkNav: false,
    siteUrl: domains.cdm,
    clientId: 'cdm',
    walletClientId: 'cdm',
    requiresGamblingMessage: true,
    links: [
      { text: 'What is CDM Sports', url: `${domains.cdm}/what-is-cdm`, description: 'Learn about CDM Sports and how it works' },
      { text: 'Contest Variety', url: `${domains.cdm}/how-to-play`, description: 'Choose from a number of sports and play options!' },
    ],
    loggedInLinks: [
      { text: 'My Teams', url: `${domains.cdm}/myTeams`, description: 'Access Your CDM Sports Teams' },
      { text: 'Contest Overview', url: `${domains.cdm}/lobby`, description: 'Take a quick look at the games open for signups' },
    ],
    footerLogoItems: {
      mobileLogo: { text: 'CDM', image: CDMMobile, url: domains.cdm },
      desktopLogo: { text: 'CDM', image: CDMDesktop, width: '117px', url: domains.cdm },
    },
  },
  shubgolf: {
    name: 'shubgolf',
    displayName: 'Fantasy Golf Championships',
    description: 'Fantasy Golf Championships',
    color: '#077233',
    wordmark: <GolfWordmark theme="light" />,
    wordmarkDark: <GolfWordmark theme="dark" />,
    shield: <GolfShield />,
    showInNetworkNav: true,
    siteUrl: domains.shubgolf,
    clientId: 'golf-front',
    walletClientId: 'oneanddone',
    requiresGamblingMessage: true,
    links: [
      { text: 'Home', url: `${domains.shubgolf}`, description: 'Fantasy Golf Championships' },
    ],
    loggedInLinks: [
      { text: 'Home', url: `${domains.shubgolf}`, description: 'Fantasy Golf Championships' },
    ],
    footerLogoItems: {
    },
  },

  shgn: {
    name: 'shgn',
    displayName: 'SportsHub Games Network',
    color: '#263d54',
    wordmark: <SHGNWordmark theme="light" />,
    showInNetworkNav: false,
    shield: <SHGNShield />,
    clientId: 'shgn',
    walletClientId: 'shgn',
    requiresGamblingMessage: true,
  },
}

const { Provider, Consumer } = React.createContext(themes.shgn)
const ThemeProvider = Provider
const ThemeConsumer = Consumer

export {
  ThemeProvider,
  ThemeConsumer,
  themes,
}



// WEBPACK FOOTER //
// ./src/contexts/theme-context.js